import { useDispatch } from '@redux';
import {
  getByIdOrdersReturn,
  passQCOrderReturn,
} from '@redux/ordersReturn/actions';
import { Form, Modal } from 'antd';
import FormItem from 'components/form/FormItem';
import useToggleModal from 'hooks/useToogleModal';
import React, { useCallback, useImperativeHandle, useState } from 'react';
import { useTranslation } from 'react-i18next';

const PassQCModal = ({ id }, ref) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const { visible, toggleModal } = useToggleModal();
  const [loading, setLoading] = useState(false);

  useImperativeHandle(ref, () => ({
    open: () => {
      toggleModal();
    },
  }));

  const handleValidation = useCallback(
    async (values) => {
      setLoading(true);
      dispatch(passQCOrderReturn({ data: { id: id, data: values } })).then(
        () => {
          dispatch(
            getByIdOrdersReturn({
              data: { id: id },
              options: { isRequestApi: true, isRefresh: true },
            }),
          ).finally(() => {
            setLoading(false);
            if (visible) toggleModal();
          });
        },
      );
    },
    [dispatch, id, toggleModal, visible],
  );

  return (
    <Modal
      open={visible}
      title={t('ordersReturn.note')}
      onCancel={() => visible && toggleModal()}
      onOk={() => form.submit()}
      width={462}
      confirmLoading={loading}
    >
      <Form form={form} layout="vertical" onFinish={handleValidation}>
        <FormItem
          name="passQCNote"
          label={t('ordersReturn.noteYourReason')}
          required
        />
      </Form>
    </Modal>
  );
};

export default React.forwardRef(PassQCModal);
